import React from 'react';
import { observer } from 'mobx-react';
import { MeasureResultsView } from './MeasureResultsView';
import { MeasureToolsetView } from './MeasureToolsetView';
import './MeasureTool.scss';
import { MeasureResultsModel } from './MeasureResultsModel';
import { MapViewInputManager } from 'cd-eft/business/MapViewInputManager/MapViewInputManager';
import { OnChangeMeasureToolHandler } from 'cd-eft/business/MapViewInputManager/MeasureInputResult';

export type MeasureDistanceUnits = 'feet' | 'meters' | 'miles' | 'kilometers';
export type MeasureAreaUnits = 'acres' | 'square-kilometers' | 'hectares' | 'square-miles';
export interface ISelectedMeasurementUnits {
  distance: MeasureDistanceUnits;
  area: MeasureAreaUnits;
  perimeter: MeasureDistanceUnits;
}
interface IMeasureToolboxViewProps {
  inputManager: MapViewInputManager;
  measureResults: MeasureResultsModel;
  hideAreaTool?: boolean;
  hideDistanceTool?: boolean;
  hideResults?: boolean;
  selectedMeasurementUnits: ISelectedMeasurementUnits;
  onChangeMeasureTool: OnChangeMeasureToolHandler;
}

export const MeasureToolboxView = observer(function (props: IMeasureToolboxViewProps) {
  return (
    <div>
      <MeasureToolsetView
        inputManager={props.inputManager}
        measureResults={props.measureResults}
        onChangeMeasureTool={props.onChangeMeasureTool}
        selectedMeasurementUnits={props.selectedMeasurementUnits}
      />

      {props.hideResults === true || <MeasureResultsView measureResults={props.measureResults} />}
    </div>
  );
});
